import React, {Component} from 'react';
import {isEmpty} from '../../utilities/frontendCommonFunctions';

export default class CheckAuthorization extends Component { // check current role
  constructor(props) {
    super(props);
  }

  checkAuth = callback => {
    const {path, feedUserDetails, feedAuthJson, loopAllLayers} = this.props;
    const {role} = feedUserDetails;
    const isOutsourceOnly = (role.length === 1 && role[0] === 3) || (role.length === 2 && (role[0] === 2 && role[1] === 3 || role[0] === 3 && role[1] === 2));
    let isAuth = false;
    let sliceIndex = 0;

    while (sliceIndex < path.length) {
      // check the authentication layer by layer (top-down) if loopAllLayers === true
      sliceIndex = path.indexOf('/', sliceIndex + 1);
      if (sliceIndex < 0 || !loopAllLayers) sliceIndex = path.length;
      let nav = path.slice(0, sliceIndex);
      let component = feedAuthJson[nav];

      // initialize the auth flag as false and loop through the role property if the component is found in the authJson
      if (component === undefined) {
        isAuth = !isOutsourceOnly;
        continue;
      } else isAuth = false;
      role.forEach(_role => {
        if (component.indexOf(_role) > -1) isAuth = true;
      });

      // return false if the path is blocked by precedents
      if (!isAuth) break;
    }

    return callback(isAuth);
  };

  componentDidMount() {
    if (!isEmpty(this.props.feedUserDetails))
      this.checkAuth(result => this.props.authenticateHandler(result));
    else this.props.authenticateHandler(false);
  };

  render() {
    return null;
  }
}
